import { SetStateAction, Dispatch } from 'react';
import { ApplicationsItemType } from '@marketplace/api';

export enum ProductsName {
  INTERGY = 'Intergy',
  PRIME_SUITE = 'PrimeSuite',
}

export enum EMApplicationStatuses {
  INSTALL = 'installing',
  INSTALLED = 'installed',
  UNINSTALL = 'uninstalling',
  UNINSTALLED = 'uninstalled',
}

// Type Embedded Mode Application
export type TEMApplication = {
  appId: string;
  appName?: string;
  company?: string;
  developer?: string;
  description?: string;
  status: EMApplicationStatuses;
  launchURI?: string;
  iconUri?: string;
  scopes?: any;
  additionalSettings?: any;
  success?: boolean;
  facing?:string;
  oauthclienttype?:string;
  oauthclientmechanism?:string;
  application_launch_type?:any;
  products?:any;
  clientid?:any;
};

export type TEMChangeApplicationOptions = {
  silence?: boolean;
};

export interface IChangeApplication {
  (application: TEMApplication, options?: TEMChangeApplicationOptions): void;
  transformAPIToEMData: (
    data: ApplicationsItemType & { status: EMApplicationStatuses }
  ) => TEMApplication;
}

export type TEMTenantState = {
  productName: ProductsName;
  apps: TEMApplication[];
  tenantId: string;
  types: string;
  facingName: string;
  oid: string;
};

export type TEmbeddedModeState = {
  state: TEMTenantState | null;
  changeApplication: IChangeApplication | null;
  getApplicationById: ((id: string) => TEMApplication | null) | null;
};

export type TEMStateManager = TEmbeddedModeState & {
  setState: Dispatch<SetStateAction<TEmbeddedModeState>>;
};

export enum Methods {
  'startup' = 'startup',
  'appStatusChanged' = 'appStatusChanged',
  'getApps' = 'getApps',
  'getVersion' = 'getVersion',
}

export type TMessage = {
  method: Methods;
  payload?: any;
};
